import { createSelector } from "reselect"
import { pickBy, find, map, get } from "lodash"
import { getSelectedDate } from "modules/security-profile/selectors/dates"
import { getOrderedCategoryItems } from "./items"
import { getData, getNonZerosKeys, getDrift } from "./exposure"
import { computeCategoryItems, computeCategoryItemsSubset } from "helpers/analyze"
import { computeDrift } from "helpers/drift"

export const getFilteredData = createSelector(
  [getData, getNonZerosKeys],
  (data, keys) => data.map(item => pickBy(item, (_, key) => keys[key])),
)

export const getCategoryItemsSubset = createSelector(
  [getOrderedCategoryItems, getNonZerosKeys],
  computeCategoryItemsSubset,
)

export const getCategoryItems = createSelector(
  [getOrderedCategoryItems, getNonZerosKeys],
  computeCategoryItems,
)

export const getDetails = createSelector(
  [getFilteredData, getDrift, getCategoryItems, getSelectedDate],
  (data, driftValues, items, date) => {
    const datum = find(data, d => d.date.isSame(date))

    return map(items, item => {
      const value = get(datum, item.id)
      let drift
      const driftValue = driftValues[item.id]
      if (driftValue) {
        drift = computeDrift(driftValue.mean, driftValue.stdDev, value)
      } else {
        drift = "-"
      }

      return {
        ...item,
        value,
        drift,
      }
    })
  },
)
